import script from "./LogoBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoBlock.vue?vue&type=script&setup=true&lang=js"

import "./LogoBlock.vue?vue&type=style&index=0&id=50d6b859&lang=scss"

const __exports__ = script;

export default __exports__